//验证数字的正则表达式
const checkCort = (rule, value, cb) => {
  // 验证数字的正则表达式
  const regCort = /^[0-9]*$/
  if (regCort.test(value)) {
    return cb()
  }
  cb(new Error('请输入合法的数字'))
}

//验证数字小数点的正则表达式
const checkCortPoint = (rule, value, cb) => {
  // 验证数字的正则表达式
  const regCort = /^[0-9]+(.[0-9]{1})?$/
  if (regCort.test(value)) {
    return cb()
  }
  cb(new Error('请输入正确的价格格式(只能是数字并且最多一位小数)'))
}

//验证缩略图
const thumbnailRules = (rule, value, callback) => {
  // console.log(rule, value)
  // if (value === undefined) {
  //   callback(new Error('缩略图不能为空1'))
  // }
  callback()
}

export {
  checkCort,
  thumbnailRules,
  checkCortPoint
}
